<template>
  <div>
    <HeaderReceipt header="เพิ่มสินค้าเข้าคลังจากการคืนสินค้า(CN)" :img_header="header_image" link_back="stock/storage/addproducttostock"/>
    <StorageCN/>
  </div>
</template>

<script>
import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt";
import HeaderImage from "@/assets/completed-task.png";
import StorageCN from "@/components/admin/stock/cn/StorageCN";
export default {
  name: "CnReceipt",
  components: {
    StorageCN,
    HeaderReceipt
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}

</script>

<style scoped>

</style>
